// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--3BUyl";
export var inner = "styles-module--inner--3feKb";
export var content = "styles-module--content--3qeNY";
export var header = "styles-module--header--28P4D";
export var heading = "styles-module--heading--uhgCy";
export var readBlog = "styles-module--readBlog--MLL_Q";